import {Component, AfterViewInit} from '@angular/core';
import {RicambiService} from '../service/ricambi.service';
import {Ordine} from '../models/ordine';
import {Carrello} from '../models/carrello';
import {MatSnackBar} from '@angular/material';
import {UserService} from '../service/user.service';
import {ServerSocket} from '../service/server-socket.service'
import {Subscription} from 'rxjs/Subscription'

@Component({
    selector: 'app-tws-carrello',
    templateUrl: './tws-carrello.component.html',
    styleUrls: ['./tws-carrello.component.css']
})
export class TwsCarrelloComponent implements AfterViewInit {
    public ordine: Ordine;
    public testo: string;
    public carrelloImport:any;
    private socketSubscription: Subscription;
    constructor(private socket: ServerSocket, private ricambiService: RicambiService,
        public snackBar: MatSnackBar, private userService: UserService
    ) {
        if (this.userService.getProfilo() == null) {
            this.userService.getLoginEvent().subscribe(item => {this.collegaWs()});
        } else {
            this.collegaWs();
        }

    }

    collegaWs() {
        const stream = this.socket.connect();
        if (stream) {
            if (!this.socketSubscription) {
                this.socketSubscription = stream.subscribe(message => {
                    if (!(this.ordine) || !this.ordine.righe) {
                        this.ordine = new Ordine();
                        this.ordine.righe = new Array<Carrello>();
                    }
                    this.ordine.righe.push(message);
                    let totale: number = 0;
                    for (var i = 0; i < this.ordine.righe.length; i++) {
                        let x: Carrello = this.ordine.righe[i];
                        totale = totale + (x.qta * x.prezzo);
                    }
                    this.ordine.totale = totale;
                });
            }
        }
    }

    ngAfterViewInit() {
        this.carrelloImport=undefined;
        this.ricambiService.getCarrello().then(heroes => this.ordine = heroes);
    }
    rimuoviCarrello(ricambio: Carrello): void {
        this.ricambiService.rimuoviCarrello(ricambio.id).then(ordine => this.callback(ordine, RicambiService.traduci("Riga eliminata")));
    }

    rimosso(carrello: Carrello) {
        this.snackBar.open(RicambiService.traduci("Prodotto rimosso al carrello"), "", {duration: 2000});
    }
    

    callback(carrello: Ordine, msg: string) {
        this.ordine = carrello;
        if (!this.ordine || !this.ordine.righe || this.ordine.righe.length == 0) {
            if(!this.ordine.importazione || this.ordine.importazione.length == 0)
                this.ordine = undefined;
        }
        
        this.snackBar.open(msg, "", {duration: 2000});
    }

    salvaOrdine() {
        this.ricambiService.salvaOrdine(this.ordine).then(ordine => this.callback(ordine, RicambiService.traduci("Ordine aggiornato")));
    }

    confermaOrdine() {
        this.ricambiService.confermaOrdine(this.ordine).then(ordine => {
            this.callback(ordine, RicambiService.traduci("Ordine confermato"));
        });
    }
    eliminaOrdine() {
        this.ricambiService.eliminaOrdine().then(ordine => this.callback(ordine, RicambiService.traduci("Ordine eliminato")));
    }

    get utente(): any {
        return this.userService.getProfilo();
    }
    
    scegliCarrello(car:any){
        this.carrelloImport=car;
    }
    importaOrdine():any{
        this.ricambiService.importaOrdine(this.ordine,""+this.carrelloImport["id"]).then(ordine => this.callback(ordine, RicambiService.traduci("Ordine importato")));
        this.carrelloImport=undefined;
    }
    importaCarrello(cat:any){
        this.scegliCarrello(cat);
        this.importaOrdine();
    }

}



// WEBPACK FOOTER //
// ./src/app/tws-carrello/tws-carrello.component.ts